import { RootSelector, getStore } from '../../reducers';
import { createSelector } from '@reduxjs/toolkit';
import { LastState, LastStateShape } from './model';
import { ACTUAL_VERSION } from './versions';
import {
  getSelectedId as getCategorySelectedId,
  getExpandedKeys as getCategoryExpandedKeys,
} from '../category/selectors';
import {
  getSelectedIds as getExtensionSelectedIds,
  getExpandedKeys as getExtensionExpandedKeys,
} from '../extension/selectors';
import {
  getSelected as getFinderSelected,
  getDetailsVisible as getFinderDetailsVisible,
} from '../finder/selectors';
import {
  getSelectedIds as getProjectSelectedIds,
  getExpanded as getProjectExpanded,
} from '../project/selectors';
import { getSearchOptions, getSearchText, getSearchUploadData } from '../search/selectors';
import { getSortingOrder, getSortingFieldKey } from '../sorting/selectors';
import {
  getSelectedIds as getTagSelectedIds,
  getExpandedMode as getTagExpandedMode,
} from '../tag/selectors';
import { getExpanded as getViewModeExpanded, getViewMode } from '../viewMode/selectors';
import { getCreative } from '../viewer/selectors';
import { getSidebarExpanded } from '../app/selectors';

export const getRoot: RootSelector<LastStateShape> = createSelector(
  getStore,
  (state) => state.lastState,
);

export const getLastStateAppliedId: RootSelector<number | null> = createSelector(
  getRoot,
  (root) => root.appliedId,
);

export const getStateInfo: RootSelector<LastState['state']> = createSelector(getStore, (state) => {
  const result: LastState['state'] = {
    version: ACTUAL_VERSION,
    data: {
      app: {
        sidebarExpanded: getSidebarExpanded(state),
      },
      category: {
        selectedId: getCategorySelectedId(state),
        expandedKeys: getCategoryExpandedKeys(state),
      },
      extension: {
        selectedIds: getExtensionSelectedIds(state),
        expandedKeys: getExtensionExpandedKeys(state),
      },
      finder: {
        selected: getFinderSelected(state),
        detailsVisible: getFinderDetailsVisible(state),
      },
      project: {
        selectedIds: getProjectSelectedIds(state),
        expanded: getProjectExpanded(state),
      },
      search: {
        text: getSearchText(state),
        uploadData: getSearchUploadData(state),
        options: getSearchOptions(state),
      },
      sorting: {
        order: getSortingOrder(state),
        fieldKey: getSortingFieldKey(state),
      },
      tag: {
        selectedIds: getTagSelectedIds(state),
        expandedMode: getTagExpandedMode(state),
      },
      viewMode: {
        value: getViewMode(state),
        expanded: getViewModeExpanded(state),
      },
      viewer: {
        creative: getCreative(state),
      },
    },
  };

  return result;
});
